import $ from "jquery";
let $window;
let React;
let get_parameter_by_name;
const indexOf =
    [].indexOf ||
    function(item) {
        for (let i = 0, l = this.length; i < l; i++) {
            if (i in this && this[i] === item) return i;
        }
        return -1;
    };

React = require("react");

get_parameter_by_name = require("../helpers/get_parameter_by_name").default;

$window = require("../helpers/helpers").default.window;

// new imports
import { connect } from "react-redux";

import * as actions from "../../actions/actions";
import SearchInfoBarContainer from "../../components/infobar";

import { CollectionCard } from "../../components/nounproject-collection-card";
import store from "../../stores/reduxStore";

class NoResults extends React.Component {
    constructor(props) {
        super(props);

        this.emptySearches = ["", null];
    }

    render() {
        let message;
        let ref;
        let searchEverythingLink;
        if (
            ((ref = this.props.query),
            indexOf.call(this.emptySearches, ref) >= 0)
        ) {
            // Message for blank search page
            message = gettext("Try searching for something above");
        } else {
            // Message for no collection
            message =
                gettext("We didn’t find any collections for") +
                " “" +
                this.props.query +
                "”";

            if (this.props.creator) {
                // Add `by this creator` if it's a creator page
                message += gettext(" by this creator");
            }

            searchEverythingLink = (
                <p>
                    <a
                        href={"/search/?q=" + this.props.query}
                        className="text-link"
                    >
                        {gettext("Search all of Noun Project")}
                    </a>
                </p>
            );
        }
        return (
            <section id="no-icon-results" className="no-results container row">
                <style>{`
                    #no-icon-results img {
                        margin: 0 auto;
                    }
                    #no-icon-results .section-heading,
                    #no-icon-results p {
                        width: 100%;
                    }
                `}</style>
                <img
                    src={require("../../../img/click.png")}
                    alt="Compass"
                    width="150"
                    height="150"
                />
                <h2 className="section-heading">{message}</h2>
                {searchEverythingLink}
            </section>
        );
    }
}

class Collection_List extends React.Component {
    buildTitle() {
        return (
            <SearchInfoBarContainer
                searchType="collections"
                store={store}
                didYouMean={this.state.didYouMean}
            />
        );
    }

    buildLoadMore() {
        if (!this.state.allCollectionsLoaded) {
            return (
                <a
                    className="button"
                    key="loadMore"
                    onClick={this.loadCollections.bind(this)}
                >
                    <span>Load more</span>
                </a>
            );
        }
    }

    UNSAFE_componentWillMount() {
        if (this.state.collections.length === 0 && this.state.query) {
            return this.loadCollections();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let fetchOffset;
        if (
            !this.multiRow &&
            this.state.totalCollections > this.state.collections.length
        ) {
            fetchOffset =
                this.state.collections.length - this.collectionLimit * 3;
            if (this.state.offset >= fetchOffset) {
                return this.loadCollections();
            }
        }
    }

    constructor(props) {
        super(props);

        this.displayName = "CollectionList";
        this.iconLimit = 6;
        this.multiRow = true;
        this.searchEndpoint = "/search/json/collection/";

        this.state = {
            query: get_parameter_by_name("q"),
            creator: get_parameter_by_name("creator"),
            collections: [],
            totalCollections: null,
            allCollectionsLoaded: false,
            page: 1,
            offset: 0,
            loading: false
        };
    }

    loadCollections() {
        let endpoint;
        let query;
        query = "";
        if (this.state.query) {
            query = encodeURIComponent(this.state.query.trim());
        }
        if (query.length > 0 && !this.state.allCollectionsLoaded) {
            if (this.multiRow) {
                this.setState({
                    loading: true
                });
            }
            endpoint =
                this.searchEndpoint +
                "?q=" +
                this.state.query +
                "&limit=24&page=" +
                this.state.page;
            if (this.state.creator) {
                endpoint = endpoint + "&creator=" + this.state.creator;
            }
            return $.get(endpoint)
                .done(
                    (_this => (data, status, xhr) => {
                        let allCollectionsLoaded;
                        let collections;

                        // save query data to redux. TODO: Replace this whole call with a redux action.
                        this.props.saveQueryInfo({
                            counts: data.counts,
                            query: data.query,
                            result_type: data.result_type,
                            scope: data.scope,
                            creator: data.creator,
                            collection: data.collection
                        });

                        collections = _this.state.collections.concat(
                            data.collections
                        );
                        allCollectionsLoaded = false;
                        if (
                            data.collections.length === 0 ||
                            collections.length === data.total
                        ) {
                            allCollectionsLoaded = true;
                        }

                        _this.setState({
                            page: _this.state.page + 1,
                            collections,
                            didYouMean: data.suggestion,
                            totalCollections: data.total || 0,
                            allCollectionsLoaded,
                            maxOffset: data.total - _this.collectionLimit,
                            loading: false
                        });
                    })(this)
                )
                .fail(
                    (_this => (xhr, status, err) => {
                        _this.setState({
                            ajaxFailure: true,
                            collections: _this.state.collections,
                            totalCollections: _this.state.totalCollections || 0,
                            loading: false
                        });
                    })(this)
                );
        }
    }

    getOffsetMargin() {
        if (this.state.offset >= this.collectionLimit) {
            return -1 * this.collectionItemWidth * this.collectionLimit;
        }
        if (this.state.offset > 0) {
            return -1 * this.collectionItemWidth * this.state.offset;
        }
        return 0;
    }

    render() {
        let collection;
        let collections;
        let collectionsTitle = this.buildTitle();
        let componentClassName;
        let icon;
        let icons;
        let idx;
        let index;
        let loadMore;
        let loadingIndicator;
        let noResults;
        let stateCollections;
        let collectionIcons;
        let ref2;

        collections = [];
        componentClassName = "collection-list multi-row";

        if (this.multiRow || this.state.collections.length > 0) {
            stateCollections = this.state.collections;
            for (idx in stateCollections) {
                collection = stateCollections[idx];
                collections.push(
                    <CollectionCard
                        collection={collection}
                        key={collection.id}
                    />
                );
            }

            // While we are loading, let's show a loading state
            if (this.state.totalCollections == null) {
                loadingIndicator = (
                    <div className="loading clearfix">
                        <div className="dot dot1" />
                        <div className="dot dot2" />
                        <div className="dot dot3" />
                        <div className="dot dot4" />
                    </div>
                );
            } else {
                // If there are no collections, show the no results module
                if (this.state.totalCollections === 0) {
                    noResults = (
                        <NoResults
                            query={this.state.query}
                            creator={this.state.creator}
                        />
                    );
                }

                // If there is more than 1 collection, show load more button
                if (this.state.totalCollections > 0) {
                    loadMore = this.buildLoadMore();
                }
            }

            let collectionsNumber = collections.length % 3;
            if (collectionsNumber !== 0) {
                // If collections are not divisible by 3, then add some extras
                for (let i = 0, l = 3 - collectionsNumber; i < l; i++) {
                    collections.push(
                        <div
                            className="card-item card-dummy"
                            key={"collection.dummy" + i}
                        />
                    );
                }
            }

            return (
                <section className={componentClassName}>
                    <div>
                        {collectionsTitle}
                        <ul
                            className="container collection-list-content"
                            style={{ marginTop: "40px" }}
                        >
                            {collections}
                            {loadingIndicator}
                        </ul>
                        {noResults}
                        {loadMore}
                    </div>
                </section>
            );
        }
        return <div className="container" />;
    }
}

function mapStateToProps() {
    return {};
}

// export default Icon_List;
export default connect(mapStateToProps, {
    saveQueryInfo: actions.saveQueryInfo
})(Collection_List);
